import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const convocationAgendaService = {
  getAll,
  search,
  deleteConvocationAgenda
};

const requestOptions = {
  method: 'GET',
  headers: Object.assign(
    {},
    {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  )
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/convocation_agendas/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}

function search(searchConvocationAgenda, pageNumber) {
  let searchUrl = `${
    process.env.REACT_APP_API_URL
  }/api/convocation_agendas/search?title=${
    searchConvocationAgenda.title
  }&archiveYear=${searchConvocationAgenda.archiveYear}&page[number]=${
    pageNumber ? pageNumber : 1
  }`;

  return fetch(searchUrl, requestOptions).then(
    responseHandleService.handleResponse
  );
}

function deleteConvocationAgenda(convocaitonAgendaId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/convocation_agendas/${convocaitonAgendaId}`;

  return axios.delete(url, requestOptionsDelete);
}
